// 配置菜单列表
const menuList = [
  {
    title: '店铺统计',
    key: '/home',
    icon: 'home',
  },

  {
    title: '订单管理',
    key: '/order',
    icon: 'file-done',
    children: [
      {
        title: '订单列表',
        key: '/order/list',
        icon: 'profile'
      },
      {
        key: '/order/returnform',
        title: '退货订单',
        icon: 'interaction'
      },
      {
        key: '/order/refundOrder',
        title: '退款订单',
        icon: 'interaction'
      },
    ]
  },
  {
    title: '商品管理',
    key: '/goods',
    icon: 'shopping',
    children: [
      {
        title: '商品列表',
        key: '/goods/list',
        icon: 'profile'
      },
      // {
      //   title: '商品日志',
      //   key: '/goods/log',
      //   icon: 'reconciliation'
      // },
    ]
  },
  {
    title: '用户列表',
    key: '/user/list',
    icon: 'user',
  },
  // {
  //   title: '优惠券',
  //   key: '/discount/list',
  //   icon: 'account-book',
  // },
  
  {
    title: '财务管理',
    key: '/finance',
    icon: 'file-done',
    children: [
      {
        title: '商家统计',
        key: '/finance/merchants',
        icon: 'profile'
      },
      {
        title: '充值',
        key: '/finance/recharge',
        icon: 'block',
      },
      {
        title: '充值记录',
        key: '/finance/rechargeLog',
        icon: 'file-text',
      },
    ]
  },
  {
    title: '店铺管理',
    key: '/merchant',
    icon: 'security-scan',
    children: [
      {
        title: '店铺设置',
        key: '/merchant/setMerchant',
        icon: 'setting'
      },
    ]
    //   {
    //     title: '商户类型',
    //     key: '/system/merchant/types',
    //     icon: 'profile'
    //   },
    // ]
  },
]

export default menuList